var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"padding":"3px"}},[_vm._v("\n    关于计算的知识 —— 这些其他人也都能学到，不论是学会使用一门编程语言，写一个健壮的、好用的库，\n    写一个前端后端编译器，甚至编写自己的编程语言和操作系统，数据库系统等。\n    成功计算的钥匙并不掌握在某个程序员手上，我们需要掌握的并且应该掌握的，\n    是一种智慧："),_c('b',[_vm._v("看到机器比第一次站在它面前时能做的更多的能力")]),_vm._v("。\n  ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-76cca26d","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Tech.vue
// module id = null
// module chunks = 